import axios, { API_URL } from './BaseService';

const AI_URL = `${API_URL}/ai/`;
const AGENT_URL = `${API_URL}/agent/`;

export async function chatWithAI(message, history = []) {
    const response = await axios.post(`${AI_URL}chat`, {
        message: message,
        history: history
    });
    return response.data;
}

export async function getSearchSuggestions(query) {
    const response = await axios.post(`${AGENT_URL}search-suggestions`, {
        query: query
    });
    return response.data;
}